const DEFINED_DARKEN_HEX_COLORS: Record<string, string> = {
  "#059669": "#057753",
  "#1988e2": "#1a79c5",
  "#e07b07": "#cd7004",
}

export function darkenHex(hex: string, percent = 10) {
  if (DEFINED_DARKEN_HEX_COLORS[hex.toLowerCase()]) {
    return DEFINED_DARKEN_HEX_COLORS[hex.toLowerCase()]
  }
  // Remove #
  hex = hex.replace(/^#/, "")

  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 4), 16)
  let b = parseInt(hex.substring(4, 6), 16)

  r = Math.max(0, Math.min(255, r - (r * percent) / 100))
  g = Math.max(0, Math.min(255, g - (g * percent) / 100))
  b = Math.max(0, Math.min(255, b - (b * percent) / 100))

  const toHex = (c: number) => Math.round(c).toString(16).padStart(2, "0")

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}
